// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__29OlQ","vLegacy":"SelectSecondary_vLegacy__2bQgS","error":"SelectSecondary_error__5Mu8-","disabled":"SelectSecondary_disabled__2uMkV"};